import { render, staticRenderFns } from "./CollectionSelector.vue?vue&type=template&id=65b34d16&scoped=true&"
import script from "./CollectionSelector.vue?vue&type=script&lang=js&"
export * from "./CollectionSelector.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSelector.vue?vue&type=style&index=0&id=65b34d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b34d16",
  null
  
)

export default component.exports